import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1>Website Under Construction</h1>
        <p>This page is not available yet. Please check back later!</p>
        <div className="not-found-links">
          <button onClick={() => navigate('/')} className="back-button">
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 